import React, { useState, useEffect, useCallback } from 'react';
import { axios, useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import kareKursLogo from '../../images/karekursbluvar.png';

const TL = (v) => new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',minimumFractionDigits:0}).format(v||0);

const PAKETLER = ['TYT Hazırlık','AYT Sayısal','AYT Sözel','AYT Eşit Ağırlık','LGS','KPSS','YDS','Tüm Paket'];

const escapeHtml = (value) => String(value || '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

const formatDate = (date) => date ? new Date(date).toLocaleDateString('tr-TR') : '-';

const addMonths = (date, months) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d.toISOString().slice(0, 10);
};

const buildInstallmentPlan = (form) => {
  if (form.taksit_modu === 'manuel' && Array.isArray(form.taksitler) && form.taksitler.length) {
    return form.taksitler.map((t, i) => ({
      no: t.taksit_no || i + 1,
      date: t.vade_tarihi,
      amount: parseFloat(t.tutar) || 0,
      durum: t.durum,
      odeme_tarihi: t.odeme_tarihi,
      odeme_yontemi: t.odeme_yontemi,
    }));
  }
  const count = form.odeme_tipi === 'pesin' ? 1 : Math.max(1, parseInt(form.taksit_sayisi, 10) || 1);
  const total = parseFloat(form.net_ucret) || 0;
  const base = Math.floor((total / count) * 100) / 100;
  const rows = [];
  let used = 0;
  for (let i = 0; i < count; i += 1) {
    const amount = i === count - 1 ? Math.max(0, total - used) : base;
    used += amount;
    rows.push({
      no: i + 1,
      date: addMonths(form.ilk_odeme_tarihi || form.baslangic_tarihi, i),
      amount
    });
  }
  return rows;
};

const getStudentName = (info = {}) => {
  const name = [info.ad, info.soyad].filter(Boolean).join(' ').trim();
  return name || info.ad_soyad || '-';
};

const asBool = (value) => value === true || value === 1 || value === '1' || value === 'true';

const extractList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.results)) return payload.results;
  return [];
};

const printCourseContract = ({ form, student }) => {
  const installments = buildInstallmentPlan(form);
  const info = student || form.sozlesme_form_bilgileri || {};
  const parentName = info.veli_adi || info.anne_adi || info.baba_adi || '-';
  const printWin = window.open('', '_blank', 'width=900,height=1000');
  if (!printWin) {
    toast.error('Sözleşme penceresi açılamadı. Tarayıcı popup iznini kontrol edin.');
    return;
  }

  const installmentRows = installments.map(row => `
    <tr>
      <td class="no">${row.no}.</td>
      <td>${formatDate(row.date)}</td>
      <td class="right">${TL(row.amount)}</td>
      <td>${row.odeme_tarihi ? formatDate(row.odeme_tarihi) : ''}</td>
      <td class="right">${row.durum === 'odendi' ? TL(row.amount) : ''}</td>
    </tr>
  `).join('');

  printWin.document.write(`<!doctype html>
    <html lang="tr">
      <head>
        <meta charset="utf-8" />
        <title>Öğrenci Kayıt Sözleşmesi - ${escapeHtml(getStudentName(info))}</title>
        <style>
          * { box-sizing: border-box; }
          @page { size: A4; margin: 0; }
          html, body { margin: 0; padding: 0; background: #f3f4f6; color: #111; font-family: Arial, Helvetica, sans-serif; font-size: 11px; }
          .page {
            position: relative;
            width: 210mm;
            height: 297mm;
            margin: 0 auto 12px;
            padding: 10mm 18mm 8mm;
            background: #fff;
            overflow: hidden;
            page-break-after: always;
            break-after: page;
          }
          .page:last-of-type { page-break-after: auto; break-after: auto; }
          .watermark {
            position: absolute;
            left: 50%;
            top: 43%;
            width: 112mm;
            transform: translate(-50%, -50%);
            opacity: 0.055;
            filter: grayscale(1);
            z-index: 0;
          }
          .content { position: relative; z-index: 1; }
          .header { text-align: center; margin-bottom: 6mm; }
          .logo { width: 42mm; max-height: 20mm; object-fit: contain; }
          h1 { margin: 3mm 0 1.5mm; font-size: 15px; letter-spacing: 0; text-align: center; }
          h2 { margin: 0 0 4mm; font-size: 13px; font-weight: 800; text-align: center; }
          .form-table, .payment-table { width: 100%; border-collapse: collapse; table-layout: fixed; }
          .form-table td, .payment-table th, .payment-table td {
            border: 1px solid #333;
            padding: 4px 7px;
            vertical-align: middle;
            height: 24px;
          }
          .form-table .label { width: 34%; text-align: center; font-weight: 800; color: #333; background: rgba(0,0,0,0.025); }
          .form-table .value { font-weight: 700; }
          .sub-label { display: inline-block; font-size: 11px; font-weight: 800; margin-right: 8px; }
          .check-row { display: flex; justify-content: center; gap: 28mm; align-items: center; }
          .box-check { display: inline-flex; align-items: center; gap: 7px; font-weight: 800; }
          .square { width: 16px; height: 16px; border: 1.6px solid #333; display: inline-flex; align-items: center; justify-content: center; font-size: 16px; line-height: 1; }
          .intro { margin: 7mm 0 5mm; line-height: 1.45; text-align: justify; }
          .dotted { border-bottom: 1px dotted #333; display: inline-block; min-width: 42mm; padding: 0 4px; font-weight: 700; text-align: center; }
          .terms { margin: 0; padding-left: 16px; line-height: 1.45; text-align: justify; }
          .terms li { margin-bottom: 4mm; }
          .social { margin-top: 7mm; display: grid; grid-template-columns: 36mm 28mm 28mm; gap: 8mm; align-items: center; }
          .total { margin: 8mm 0 7mm; text-align: right; font-size: 13px; font-weight: 800; }
          .payment-table { font-size: 11px; }
          .payment-table th { text-align: center; font-weight: 800; background: rgba(0,0,0,0.03); }
          .payment-table td { height: 8mm; }
          .payment-table .no { width: 10mm; text-align: center; }
          .right { text-align: right; }
          .approval { margin-top: 14mm; line-height: 1.45; font-size: 12px; }
          .sign-name { margin-top: 13mm; font-weight: 800; }
          .signature-line { margin-top: 7mm; width: 65mm; border-bottom: 1px solid #111; height: 18mm; }
          .note { margin-top: 8mm; border: 1px solid #333; min-height: 12mm; padding: 6px 8px; }
          .actions { max-width: 210mm; margin: 12px auto; display: flex; justify-content: flex-end; }
          button { border: 0; background: #ef334e; color: #fff; border-radius: 8px; padding: 10px 18px; font-weight: 800; cursor: pointer; }
          @media print {
            html, body { width: 210mm; background: #fff; }
            .page { margin: 0; width: 210mm; height: 297mm; }
            .actions { display: none; }
          }
        </style>
      </head>
      <body>
        <div class="page">
          <img class="watermark" src="${kareKursLogo}" alt="" />
          <div class="content">
            <div class="header">
              <img class="logo" src="${kareKursLogo}" alt="Kare Kurs Vip Bulvar" />
              <h1>ÖĞRENCİ KAYIT SÖZLEŞMESİ</h1>
              <h2>DERSHANE</h2>
            </div>

            <table class="form-table">
              <tbody>
                <tr><td class="label">ÖĞRENCİNİN ADI SOYADI</td><td class="value" colspan="2">${escapeHtml(getStudentName(info))}</td></tr>
                <tr><td class="label">OKULU</td><td class="value" colspan="2">${escapeHtml(info.okul_adi || '-')}</td></tr>
                <tr>
                  <td class="label">SINIFI</td>
                  <td class="value">${escapeHtml(info.sinif_adi || '-')}</td>
                  <td><span class="sub-label">ALANI:</span> ${escapeHtml(info.alan || info.sinav_turu || '-')}</td>
                </tr>
                <tr>
                  <td class="label">ANNE ADI</td>
                  <td class="value">${escapeHtml(info.anne_adi || '-')}</td>
                  <td><span class="sub-label">TELEFON NUMARASI:</span> ${escapeHtml(info.anne_telefon || '-')}</td>
                </tr>
                <tr>
                  <td class="label">BABA ADI</td>
                  <td class="value">${escapeHtml(info.baba_adi || '-')}</td>
                  <td><span class="sub-label">TELEFON NUMARASI:</span> ${escapeHtml(info.baba_telefon || '-')}</td>
                </tr>
                <tr><td class="label">ÖĞRENCİ TELEFON NUMARASI</td><td class="value" colspan="2">${escapeHtml(info.telefon || '-')}</td></tr>
                <tr><td class="label">ÖĞRENCİ T.C. KİMLİK NUMARASI</td><td class="value" colspan="2">${escapeHtml(info.tc_kimlik || '-')}</td></tr>
                <tr><td class="label">ÖĞRENCİ DOĞUM TARİHİ</td><td class="value" colspan="2">${escapeHtml(info.dogum_tarihi ? formatDate(info.dogum_tarihi) : '-')}</td></tr>
                <tr><td class="label">ADRES</td><td class="value" colspan="2" style="height: 18mm;">${escapeHtml(info.adres || '-')}</td></tr>
                <tr>
                  <td class="label">ŞEHİT VEYA GAZİ<br />ÇOCUĞU OLMA DURUMU</td>
                  <td colspan="2">
                    <div class="check-row">
                      <span class="box-check">EVET <span class="square">${info.sehit_gazi_cocugu ? '×' : ''}</span></span>
                      <span class="box-check">HAYIR <span class="square">${info.sehit_gazi_cocugu ? '' : '×'}</span></span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <p class="intro">
              İş bu sözleşme Osmaniye Özel Kare Kurs Vip Eğitim Kurumları ile
              <span class="dotted">${escapeHtml(getStudentName(info))}</span>'nin velisi olan
              <span class="dotted">${escapeHtml(parentName)}</span> arasında karşılıklı yükümlülükleri belirlemek amacıyla düzenlenmiştir.
            </p>

            <ol class="terms">
              <li>Her öğrenci kayıt için belirtilen miktarda peşinat verecektir. (${escapeHtml(form.egitim_yili)} eğitim dönemi için ${TL(form.net_ucret)})</li>
              <li>Veli öğrencisinin kaydını, kayıt tarihinden itibaren 60 günden sonra silemez. Kayıt silmesi durumunda ücreti ödemek zorundadır.</li>
              <li>Öğrencinin gelmediği günler öğrencinin sorumluluğunda olup, toplam kurs ücretinden düşme gibi bir durum söz konusu değildir. Eğitim ücreti yıllık olup ödeme kolaylığı olması adına kurumumuzca taksitlere bölünmüştür.</li>
            </ol>

            <div class="social">
              <strong>4. Sosyal Medya İzni:</strong>
              <span class="box-check">EVET <span class="square">${info.sosyal_medya_izni ? '×' : ''}</span></span>
              <span class="box-check">HAYIR <span class="square">${info.sosyal_medya_izni ? '' : '×'}</span></span>
            </div>
          </div>
        </div>

        <div class="page">
          <img class="watermark" src="${kareKursLogo}" alt="" />
          <div class="content">
            <div class="header">
              <img class="logo" src="${kareKursLogo}" alt="Kare Kurs Vip Bulvar" />
            </div>

            <div class="total">TOPLAM KURS ÜCRETİ: ${TL(form.net_ucret)}</div>
            <table class="payment-table">
              <thead>
                <tr>
                  <th style="width: 10mm;"></th>
                  <th>ÖDEYECEĞİ TARİH</th>
                  <th>ÖDENECEK TUTAR</th>
                  <th>ÖDEDİĞİ TARİH</th>
                  <th>ÖDENEN TUTAR</th>
                </tr>
              </thead>
              <tbody>${installmentRows}</tbody>
            </table>

            <div class="approval">
              İş bu sözleşme <strong>${formatDate(new Date())}</strong> tarihinde tek nüsha olarak düzenlenmiş ve taraflarca imza altına alınmıştır.
            </div>

            ${form.notlar ? `<div class="note"><strong>Notlar:</strong><br />${escapeHtml(form.notlar)}</div>` : ''}

            <div class="sign-name">AD-SOYAD VE İMZA</div>
            <div class="signature-line"></div>
            <div style="margin-top: 4mm; font-weight: 700;">${escapeHtml(parentName)}</div>
          </div>
        </div>
        <div class="actions"><button onclick="window.print()">Sözleşmeyi Yazdır</button></div>
      </body>
    </html>`);
  printWin.document.close();
  setTimeout(() => printWin.print(), 500);
};

// ── Modal: Yeni Sözleşme ───────────────────────────────────────── 
const initialManualInstallment = (date) => ({
  vade_tarihi: date,
  tutar: '',
  durum: 'bekliyor',
  odeme_tarihi: '',
  odeme_yontemi: '',
});

const buildStudentFormInfo = (student = {}) => ({
  ad: student.ad || '',
  soyad: student.soyad || '',
  ad_soyad: student.ad_soyad || [student.ad, student.soyad].filter(Boolean).join(' '),
  okul_adi: student.okul_adi || '',
  sinif_adi: student.sinif_adi || '',
  sinav_turu: student.sinav_turu || student.egitim_turu || '',
  alan: student.alan || '',
  anne_adi: student.anne_adi || '',
  anne_telefon: student.anne_telefon || '',
  baba_adi: student.baba_adi || '',
  baba_telefon: student.baba_telefon || '',
  telefon: student.telefon || '',
  tc_kimlik: student.tc_kimlik || student.tc_no || '',
  dogum_tarihi: student.dogum_tarihi ? String(student.dogum_tarihi).slice(0, 10) : '',
  adres: student.adres || '',
  sehit_gazi_cocugu: asBool(student.sehit_gazi_cocugu),
  sosyal_medya_izni: asBool(student.sosyal_medya_izni),
});

function SozlesmeModal({ sablonlar, onSave, onClose }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSinif, setSelectedSinif] = useState('');
  const [ogrenciler, setOgrenciler] = useState([]);
  const [siniflar, setSiniflar] = useState([]);
  const [ogrenciLoading, setOgrenciLoading] = useState(false);
  const [form, setForm] = useState({
    ogrenci_id:'', egitim_yili: new Date().getFullYear()+'-'+(new Date().getFullYear()+1),
    paket:'TYT Hazırlık', egitim_turu:'TYT',
    baslangic_tarihi: new Date().toISOString().slice(0,10),
    bitis_tarihi: new Date(new Date().setMonth(new Date().getMonth()+9)).toISOString().slice(0,10),
    brut_ucret:'', sablon_id:'', indirim_tipi:'', indirim_tutar:'0', indirim_yuzde:'0',
    net_ucret:'', odeme_tipi:'taksit', taksit_sayisi:'9',
    ilk_odeme_tarihi: new Date().toISOString().slice(0,10), taksit_modu:'otomatik',
    taksitler: [initialManualInstallment(new Date().toISOString().slice(0,10))],
    sozlesme_form_bilgileri: buildStudentFormInfo(),
    notlar:'',
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const timer = setTimeout(async () => {
      setOgrenciLoading(true);
      try {
        const params = new URLSearchParams({ limit: '500' });
        if (searchTerm.trim()) params.set('arama', searchTerm.trim());
        if (selectedSinif.startsWith('id:')) params.set('sinif_id', selectedSinif.slice(3));
        if (selectedSinif.startsWith('ad:')) params.set('sinif', selectedSinif.slice(3));
        const r = await axios.get(`/muhasebe/sozlesmeler/ogrenci-secimi?${params}`);
        setOgrenciler(extractList(r.data));
      } catch {
        setOgrenciler([]);
      } finally {
        setOgrenciLoading(false);
      }
    }, 250);
    return () => clearTimeout(timer);
  }, [searchTerm, selectedSinif]);

  useEffect(() => {
    axios.get('/siniflar')
      .then(r => setSiniflar(extractList(r.data)))
      .catch(() => setSiniflar([]));
  }, []);

  // --- Yardımcı Fonksiyonlar ---
  const hesaplaNet = (brut, indirimT, indirimY) => {
    const b  = parseFloat(brut) || 0;
    const it = parseFloat(indirimT) || 0;
    const iy = parseFloat(indirimY) || 0;
    const ind = it > 0 ? it : (b * iy / 100);
    return Math.max(0, b - ind);
  };

  const handleChange = (field, val) => {
    setForm(f => {
      const nf = { ...f, [field]: val };
      if (['brut_ucret','indirim_tutar','indirim_yuzde'].includes(field)) {
        nf.net_ucret = hesaplaNet(nf.brut_ucret, nf.indirim_tutar, nf.indirim_yuzde).toFixed(2);
      }
      return nf;
    });
  };

  const handleStudentSelect = (studentId) => {
    const student = ogrenciler.find(o => String(o.id) === String(studentId));
    setForm(f => ({
      ...f,
      ogrenci_id: studentId,
      egitim_turu: student?.sinav_turu || student?.egitim_turu || f.egitim_turu,
      sozlesme_form_bilgileri: buildStudentFormInfo(student),
    }));
  };

  const handleFormInfoChange = (field, val) => {
    setForm(f => ({
      ...f,
      sozlesme_form_bilgileri: {
        ...f.sozlesme_form_bilgileri,
        [field]: val,
      },
    }));
  };

  const handleInstallmentChange = (index, field, value) => {
    setForm(f => ({
      ...f,
      taksitler: f.taksitler.map((row, i) => i === index ? { ...row, [field]: value } : row),
    }));
  };

  const addManualInstallment = () => {
    setForm(f => ({
      ...f,
      taksitler: [...f.taksitler, initialManualInstallment(addMonths(f.ilk_odeme_tarihi || f.baslangic_tarihi, f.taksitler.length))],
    }));
  };

  const removeManualInstallment = (index) => {
    setForm(f => ({
      ...f,
      taksitler: f.taksitler.length > 1 ? f.taksitler.filter((_, i) => i !== index) : f.taksitler,
    }));
  };

  const manualTotal = form.taksitler.reduce((sum, t) => sum + (parseFloat(t.tutar) || 0), 0);
  const manualDiff = manualTotal - (parseFloat(form.net_ucret) || 0);

  const buildPayload = () => {
    const payload = { ...form };
    if (form.taksit_modu === 'manuel') {
      payload.taksitler = form.taksitler.map((t, i) => ({
        taksit_no: i + 1,
        vade_tarihi: t.vade_tarihi,
        tutar: parseFloat(t.tutar) || 0,
        durum: t.durum || 'bekliyor',
        ...(t.odeme_tarihi ? { odeme_tarihi: t.odeme_tarihi } : {}),
        ...(t.odeme_yontemi ? { odeme_yontemi: t.odeme_yontemi } : {}),
      }));
    } else {
      delete payload.taksitler;
    }
    return payload;
  };

  const handleSablonChange = (sablonId) => {
    if (!sablonId) {
      setForm(f => ({ ...f, sablon_id:'', indirim_tipi:'', indirim_tutar:'0', indirim_yuzde:'0',
        net_ucret: (parseFloat(f.brut_ucret)||0).toFixed(2) }));
      return;
    }
    const sablon = sablonlar.find(s => String(s.id) === sablonId);
    if (!sablon) return;
    const brut = parseFloat(form.brut_ucret) || 0;
    const yuzde = parseFloat(sablon.yuzde) || 0;
    const sabit = parseFloat(sablon.sabit_tutar) || 0;
    const indirimTutar = yuzde > 0 ? 0 : sabit;
    const indirimYuzde = yuzde > 0 ? yuzde : 0;
    const net = Math.max(0, brut - (yuzde > 0 ? brut * yuzde / 100 : sabit));
    setForm(f => ({
      ...f,
      sablon_id:     sablonId,
      indirim_tipi:  sablon.tip,
      indirim_tutar: indirimTutar.toFixed(2),
      indirim_yuzde: indirimYuzde.toFixed(2),
      net_ucret:     net.toFixed(2),
    }));
  };

  const handleSubmit = async () => {
    if (!form.ogrenci_id || !form.brut_ucret || !form.net_ucret) {
      toast.error('Zorunlu alanları doldurun'); return;
    }
    if (form.taksit_modu === 'manuel') {
      const invalidRow = form.taksitler.find(t => !t.vade_tarihi || !(parseFloat(t.tutar) > 0) || !t.durum);
      if (invalidRow) {
        toast.error('Manuel taksitlerde vade tarihi, tutar ve durum zorunludur'); return;
      }
      if (Math.abs(manualDiff) > 0.01) {
        toast.error(`Manuel taksit toplamı net ücretten ${TL(Math.abs(manualDiff))} ${manualDiff > 0 ? 'fazla' : 'eksik'}`); return;
      }
    }
    setSaving(true);
    try { await onSave(buildPayload()); } finally { setSaving(false); }
  };

  const secilenSablon = sablonlar.find(s => String(s.id) === form.sablon_id);
  const filtreliOgrenciler = ogrenciler;
  const formInfo = form.sozlesme_form_bilgileri;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 960 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">📋 Yeni Sözleşme</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="muh-grid-2">
          
          {/* Öğrenci Seçimi ve Filtreleme Bölümü */}
          <div className="form-group" style={{ gridColumn: '1/-1', background: 'var(--bg-elevated)', padding: '15px', borderRadius: '12px', border: '1px solid var(--border)' }}>
            <label className="form-label" style={{ fontWeight: 800, color: 'var(--blue)', marginBottom: '10px', display: 'block' }}>
              Öğrenci Seçimi *
            </label>
            
            <div className="muh-filter-row" style={{ marginBottom: 10 }}>
              <div style={{ flex: 2 }}>
                <input 
                  className="form-input" 
                  placeholder="🔍 İsme göre öğrenci ara..." 
                  value={searchTerm} 
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <select
                  className="form-input"
                  value={selectedSinif} 
                  onChange={e => setSelectedSinif(e.target.value)}
                >
                  <option value="">Tüm Sınıflar</option>
                  {siniflar.map(s => {
                    const label = s.ad || s.sinif_adi || s.name || `Sınıf #${s.id}`;
                    const value = s.id ? `id:${s.id}` : `ad:${label}`;
                    return <option key={value} value={value}>{label}</option>;
                  })}
                </select>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', fontWeight: 700 }}>
                Listeden öğrenci seçin
              </div>
              <div style={{ fontSize: '0.72rem', color: 'var(--blue)', fontWeight: 800 }}>
                {ogrenciLoading ? 'Yükleniyor...' : `${filtreliOgrenciler.length} sonuç`}
              </div>
            </div>
            <select
              className="form-input"
              size={Math.min(7, Math.max(filtreliOgrenciler.length, 4))}
              value={form.ogrenci_id}
              onChange={e => handleStudentSelect(e.target.value)}
              style={{ height: 'auto', padding: '6px', background: '#fff', border: '1.5px solid var(--border)' }}
            >
              {filtreliOgrenciler.length === 0 ? (
                <option value="" disabled>{ogrenciLoading ? 'Öğrenciler yükleniyor...' : 'Sonuç bulunamadı'}</option>
              ) : (
                filtreliOgrenciler.map(o => (
                  <option key={o.id} value={o.id}>
                    {o.ad} {o.soyad} | {o.sinif_adi || 'Sınıf Yok'} | No: {o.ogrenci_no || '-'}
                  </option>
                ))
              )}
            </select>
            {form.ogrenci_id && (
              <div style={{ marginTop: 8, fontSize: '0.82rem', color: '#10B981', fontWeight: 700 }}>
                ✅ Seçili: {getStudentName(formInfo)}
              </div>
            )}
          </div>

          {form.ogrenci_id && (
            <div className="form-group" style={{ gridColumn:'1/-1', background:'var(--bg-elevated)', padding:15, borderRadius:12, border:'1px solid var(--border)' }}>
              <label className="form-label" style={{ fontWeight:800, marginBottom:10, display:'block' }}>
                Sözleşme Form Bilgileri
              </label>
              <div className="muh-grid-2">
                <div className="form-group">
                  <label className="form-label">Ad</label>
                  <input className="form-input" value={formInfo.ad} onChange={e => handleFormInfoChange('ad', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Soyad</label>
                  <input className="form-input" value={formInfo.soyad} onChange={e => handleFormInfoChange('soyad', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Okul</label>
                  <input className="form-input" value={formInfo.okul_adi} onChange={e => handleFormInfoChange('okul_adi', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Sınıf</label>
                  <input className="form-input" value={formInfo.sinif_adi} onChange={e => handleFormInfoChange('sinif_adi', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Sınav Türü</label>
                  <input className="form-input" value={formInfo.sinav_turu} onChange={e => handleFormInfoChange('sinav_turu', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Alan</label>
                  <input className="form-input" value={formInfo.alan} onChange={e => handleFormInfoChange('alan', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Anne Adı</label>
                  <input className="form-input" value={formInfo.anne_adi} onChange={e => handleFormInfoChange('anne_adi', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Anne Telefon</label>
                  <input className="form-input" value={formInfo.anne_telefon} onChange={e => handleFormInfoChange('anne_telefon', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Baba Adı</label>
                  <input className="form-input" value={formInfo.baba_adi} onChange={e => handleFormInfoChange('baba_adi', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Baba Telefon</label>
                  <input className="form-input" value={formInfo.baba_telefon} onChange={e => handleFormInfoChange('baba_telefon', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Telefon</label>
                  <input className="form-input" value={formInfo.telefon} onChange={e => handleFormInfoChange('telefon', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">T.C. Kimlik</label>
                  <input className="form-input" value={formInfo.tc_kimlik} onChange={e => handleFormInfoChange('tc_kimlik', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Doğum Tarihi</label>
                  <input className="form-input" type="date" value={formInfo.dogum_tarihi} onChange={e => handleFormInfoChange('dogum_tarihi', e.target.value)} />
                </div>
                <label style={{ display:'flex', alignItems:'center', gap:8, fontWeight:700 }}>
                  <input type="checkbox" checked={formInfo.sehit_gazi_cocugu} onChange={e => handleFormInfoChange('sehit_gazi_cocugu', e.target.checked)} />
                  Şehit/Gazi Çocuğu
                </label>
                <label style={{ display:'flex', alignItems:'center', gap:8, fontWeight:700 }}>
                  <input type="checkbox" checked={formInfo.sosyal_medya_izni} onChange={e => handleFormInfoChange('sosyal_medya_izni', e.target.checked)} />
                  Sosyal Medya İzni
                </label>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Adres</label>
                  <textarea className="form-input" rows={2} value={formInfo.adres} onChange={e => handleFormInfoChange('adres', e.target.value)} />
                </div>
              </div>
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Eğitim Yılı</label>
            <input className="form-input" value={form.egitim_yili} onChange={e => handleChange('egitim_yili', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Paket</label>
            <select className="form-input" value={form.paket} onChange={e => handleChange('paket', e.target.value)}>
              {PAKETLER.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Başlangıç</label>
            <input className="form-input" type="date" value={form.baslangic_tarihi} onChange={e => handleChange('baslangic_tarihi', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Bitiş</label>
            <input className="form-input" type="date" value={form.bitis_tarihi} onChange={e => handleChange('bitis_tarihi', e.target.value)} />
          </div>

          <div className="form-group">
            <label className="form-label">Brüt Ücret (₺) *</label>
            <input className="form-input" type="number" value={form.brut_ucret}
              onChange={e => handleChange('brut_ucret', e.target.value)} placeholder="0" />
          </div>

          <div className="form-group">
            <label className="form-label">İndirim Şablonu</label>
            <select className="form-input" value={form.sablon_id}
              onChange={e => handleSablonChange(e.target.value)}>
              <option value="">— Şablon seçin (opsiyonel) —</option>
              {sablonlar.map(s => (
                <option key={s.id} value={s.id}>
                  {s.ad} {parseFloat(s.yuzde) > 0 ? `(%${s.yuzde})` : parseFloat(s.sabit_tutar) > 0 ? `(${TL(s.sabit_tutar)})` : ''}
                </option>
              ))}
            </select>
          </div>

          {secilenSablon && (
            <div style={{ gridColumn:'1/-1', padding:'10px 14px', borderRadius:10,
              background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.3)',
              display:'flex', alignItems:'center', gap:12 }}>
              <span style={{ fontSize:'1.3rem' }}>✅</span>
              <div>
                <div style={{ fontWeight:700, fontSize:'0.875rem', color:'#065F46' }}>
                  {secilenSablon.ad} uygulandı
                </div>
                <div style={{ fontSize:'0.78rem', color:'#065F46' }}>
                  {parseFloat(secilenSablon.yuzde)>0
                    ? `%${secilenSablon.yuzde} indirim → ${TL((parseFloat(form.brut_ucret)||0)*parseFloat(secilenSablon.yuzde)/100)} indirim`
                    : `${TL(secilenSablon.sabit_tutar)} sabit indirim`}
                </div>
              </div>
              <button style={{ marginLeft:'auto', background:'none', border:'none', cursor:'pointer', color:'#065F46', fontSize:'1rem' }}
                onClick={() => handleSablonChange('')}>✕</button>
            </div>
          )}

          {!form.sablon_id && (
            <>
              <div className="form-group">
                <label className="form-label">İndirim Tutarı (₺)</label>
                <input className="form-input" type="number" value={form.indirim_tutar}
                  onChange={e => handleChange('indirim_tutar', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">İndirim % (veya tutar kullan)</label>
                <input className="form-input" type="number" value={form.indirim_yuzde}
                  onChange={e => handleChange('indirim_yuzde', e.target.value)} />
              </div>
            </>
          )}

          <div className="form-group" style={{ gridColumn:'1/-1' }}>
            <label className="form-label">Net Ücret (₺) *</label>
            <div style={{ position:'relative' }}>
              <input className="form-input" type="number" value={form.net_ucret}
                onChange={e => handleChange('net_ucret', e.target.value)}
                style={{ fontWeight:800, fontSize:'1.15rem', color:'var(--blue)', paddingRight:120 }} />
              {parseFloat(form.brut_ucret) > 0 && parseFloat(form.brut_ucret) !== parseFloat(form.net_ucret) && (
                <div style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)',
                  fontSize:'0.75rem', color:'#EF4444', fontWeight:700 }}>
                  -{TL(parseFloat(form.brut_ucret) - parseFloat(form.net_ucret))} indirim
                </div>
              )}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Ödeme Tipi</label>
            <select className="form-input" value={form.odeme_tipi} onChange={e => handleChange('odeme_tipi', e.target.value)}>
              <option value="pesin">Peşin</option>
              <option value="taksit">Taksit</option>
              <option value="kredi_karti">Kredi Kartı</option>
              <option value="senet">Senet</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Taksit Sayısı</label>
            <input className="form-input" type="number" min="1" max="24" value={form.taksit_sayisi}
              onChange={e => handleChange('taksit_sayisi', e.target.value)}
              disabled={form.odeme_tipi === 'pesin' || form.taksit_modu === 'manuel'} />
          </div>

          <div className="form-group" style={{ gridColumn:'1/-1' }}>
            <label className="form-label">Taksit Modu</label>
            <div style={{ display:'flex', gap:8 }}>
              <button type="button" className={`chip ${form.taksit_modu === 'otomatik' ? 'active' : ''}`} onClick={() => handleChange('taksit_modu', 'otomatik')}>
                Otomatik
              </button>
              <button type="button" className={`chip ${form.taksit_modu === 'manuel' ? 'active' : ''}`} onClick={() => handleChange('taksit_modu', 'manuel')}>
                Manuel
              </button>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">İlk Taksit Tarihi</label>
            <input className="form-input" type="date" value={form.ilk_odeme_tarihi}
              onChange={e => handleChange('ilk_odeme_tarihi', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Aylık Taksit Tutarı (~)</label>
            <div style={{ padding:'10px 14px', background:'var(--bg-elevated)', borderRadius:10,
              fontWeight:800, color:'#10B981', fontFamily:'var(--font-ui)' }}>
              {form.taksit_modu === 'manuel' ? TL(manualTotal) : TL((parseFloat(form.net_ucret)||0) / (parseInt(form.taksit_sayisi)||1))}
            </div>
          </div>

          {form.taksit_modu === 'manuel' && (
            <div className="form-group" style={{ gridColumn:'1/-1' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
                <label className="form-label" style={{ margin:0 }}>Manuel Taksitler</label>
                <button type="button" className="btn btn-outline btn-sm" onClick={addManualInstallment}>+ Satır Ekle</button>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:8, overflowX:'auto', paddingBottom:4 }}>
                {form.taksitler.map((t, i) => (
                  <div key={i} style={{ display:'grid', gridTemplateColumns:'42px 145px 120px 120px 145px 145px 34px', gap:6, alignItems:'center', minWidth:760 }}>
                    <div style={{ fontWeight:800, textAlign:'center' }}>#{i + 1}</div>
                    <input className="form-input" type="date" value={t.vade_tarihi} onChange={e => handleInstallmentChange(i, 'vade_tarihi', e.target.value)} />
                    <input className="form-input" type="number" placeholder="Tutar" value={t.tutar} onChange={e => handleInstallmentChange(i, 'tutar', e.target.value)} />
                    <select className="form-input" value={t.durum} onChange={e => handleInstallmentChange(i, 'durum', e.target.value)}>
                      <option value="bekliyor">Bekliyor</option>
                      <option value="odendi">Ödendi</option>
                      <option value="gecikti">Gecikti</option>
                      <option value="iptal">İptal</option>
                    </select>
                    <input className="form-input" type="date" value={t.odeme_tarihi} onChange={e => handleInstallmentChange(i, 'odeme_tarihi', e.target.value)} />
                    <select className="form-input" value={t.odeme_yontemi} onChange={e => handleInstallmentChange(i, 'odeme_yontemi', e.target.value)}>
                      <option value="">Yöntem</option>
                      <option value="nakit">Nakit</option>
                      <option value="kredi_karti">Kredi Kartı</option>
                      <option value="banka_havalesi">Banka Havalesi</option>
                      <option value="pos">POS</option>
                    </select>
                    <button type="button" className="btn btn-ghost btn-sm" onClick={() => removeManualInstallment(i)}>✕</button>
                  </div>
                ))}
              </div>
              <div style={{ marginTop:8, fontSize:'0.82rem', fontWeight:800, color:Math.abs(manualDiff) > 0.01 ? '#EF4444' : '#10B981' }}>
                Toplam: {TL(manualTotal)} · Net ücret farkı: {TL(Math.abs(manualDiff))}
              </div>
            </div>
          )}

          <div className="form-group" style={{ gridColumn:'1/-1' }}>
            <label className="form-label">Notlar</label>
            <textarea className="form-input" rows={2} value={form.notlar}
              onChange={e => handleChange('notlar', e.target.value)} />
          </div>
        </div>

        <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:16 }}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving ? <><div className="spinner" style={{width:16,height:16}} /> Kaydediliyor...</> : '💾 Sözleşme Oluştur'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Modal: Tahsilat ──────────────────────────────────────────────
function TahsilatModal({ taksit, onSave, onClose }) {
  const [form, setForm] = useState({
    tutar: taksit?.tutar || '',
    odeme_yontemi: 'nakit',
    odeme_tarihi: new Date().toISOString().slice(0,10),
    makbuz_no: '', notlar: '',
  });
  const [saving, setSaving] = useState(false);
  const handleSubmit = async () => {
    setSaving(true);
    try { await onSave({ ...form, taksit_id: taksit.id }); }
    finally { setSaving(false); }
  };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">💳 Tahsilat Al</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div style={{ background:'var(--bg-elevated)', borderRadius:12, padding:'12px 16px', marginBottom:16 }}>
          <div style={{ fontWeight:700 }}>{taksit.ad} {taksit.soyad} — Taksit #{taksit.taksit_no}</div>
          <div style={{ fontSize:'0.82rem', color:'var(--text-muted)' }}>
            Vade: {new Date(taksit.vade_tarihi).toLocaleDateString('tr-TR')} · {TL(taksit.tutar)}
          </div>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          <div className="form-group"><label className="form-label">Tahsil Tutarı (₺) *</label>
            <input className="form-input" type="number" value={form.tutar} onChange={e => setForm(f=>({...f,tutar:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">Ödeme Yöntemi</label>
            <select className="form-input" value={form.odeme_yontemi} onChange={e => setForm(f=>({...f,odeme_yontemi:e.target.value}))}>
              <option value="nakit">Nakit</option>
              <option value="kredi_karti">Kredi Kartı</option>
              <option value="banka_havalesi">Banka Havalesi</option>
              <option value="pos">POS</option>
            </select></div>
          <div className="form-group"><label className="form-label">Ödeme Tarihi</label>
            <input className="form-input" type="date" value={form.odeme_tarihi} onChange={e => setForm(f=>({...f,odeme_tarihi:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">Makbuz / Fiş No</label>
            <input className="form-input" value={form.makbuz_no} onChange={e => setForm(f=>({...f,makbuz_no:e.target.value}))} /></div>
        </div>
        <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:16 }}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving ? <><div className="spinner" style={{width:16,height:16}} /> Kaydediliyor...</> : '✅ Tahsilatı Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Ana Sayfa ────────────────────────────────────────────────────
export default function SozlesmelerPage() {
  const { user } = useAuth();
  const canSendWhatsAppReminder = ['kurucu', 'muhasebe'].includes(user?.rol);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 900 : false);
  const [sozlesmeler, setSozlesmeler] = useState([]);
  const [sablonlar, setSablonlar]     = useState([]);
  const [loading, setLoading]         = useState(true);
  const [total, setTotal]             = useState(0);
  const [filtre, setFiltre]           = useState({ durum:'', sayfa:1 });
  const [showModal, setShowModal]     = useState(false);
  const [secili, setSecili]           = useState(null);
  const [detay, setDetay]             = useState(null);
  const [tahsilatTaksit, setTahsilatTaksit] = useState(null);
  const [whatsAppSendingId, setWhatsAppSendingId] = useState(null);

  // Toplu işlem seçimi
  const [selectedIds, setSelectedIds] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ ...filtre });
      const r = await axios.get(`/muhasebe/sozlesmeler?${params}`);
      if (r.data.success) { 
        setSozlesmeler(r.data.data); 
        setTotal(r.data.total);
        setSelectedIds([]); // Filtre değişince seçimleri temizle
      }
    } catch {} finally { setLoading(false); }
  }, [filtre]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    axios.get('/muhasebe/indirim-sablonlari').then(r => { if (r.data.success) setSablonlar(r.data.data || []); }).catch(()=>{});
  }, []);

  const handleDetay = async (id) => {
    setSecili(id);
    try {
      const r = await axios.get(`/muhasebe/sozlesmeler/${id}`);
      if (r.data.success) setDetay(r.data.data);
    } catch {}
  };

  const handleSave = async (form) => {
    try {
      await axios.post('/muhasebe/sozlesmeler', form);
      toast.success('Sözleşme oluşturuldu!');
      printCourseContract({
        form,
        student: form.sozlesme_form_bilgileri,
        representativeName: [user?.ad, user?.soyad].filter(Boolean).join(' ')
      });
      setShowModal(false); load();
    } catch (e) {
      toast.error(e.response?.data?.message || 'Hata');
    }
  };

  // ── TEKLİ VE TOPLU İŞLEM FONKSİYONLARI ──────────────────────────
  
  const handleDelete = async (id) => {
    if(!window.confirm("Bu sözleşmeyi tamamen silmek istediğinize emin misiniz? Bu işlem geri alınamaz.")) return;
    try {
      await axios.delete(`/muhasebe/sozlesmeler/${id}`);
      toast.success('Sözleşme silindi');
      if(secili === id) setSecili(null);
      load();
    } catch (e) { toast.error('Silme işlemi başarısız'); }
  };

  const handleStatusUpdate = async (id, newDurum) => {
    try {
      await axios.put(`/muhasebe/sozlesmeler/${id}`, { durum: newDurum });
      toast.success(`Durum güncellendi: ${newDurum}`);
      if (secili === id) handleDetay(id);
      load();
    } catch (e) { toast.error('Güncelleme başarısız'); }
  };

  const toggleSelect = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const toggleSelectAll = () => {
    if (selectedIds.length === sozlesmeler.length) setSelectedIds([]);
    else setSelectedIds(sozlesmeler.map(s => s.id));
  };

  const handleBulkDelete = async () => {
    if(!window.confirm(`${selectedIds.length} adet sözleşmeyi SİLMEK istediğinize emin misiniz?`)) return;
    try {
      await axios.post('/muhasebe/sozlesmeler/bulk-delete', { ids: selectedIds });
      toast.success('Seçili kayıtlar silindi');
      load();
    } catch { toast.error('Toplu silme başarısız'); }
  };

  const handleBulkStatus = async (newDurum) => {
    if(!window.confirm(`${selectedIds.length} adet sözleşmeyi '${newDurum}' durumuna getirmek istiyor musunuz?`)) return;
    try {
      await axios.post('/muhasebe/sozlesmeler/bulk-status', { ids: selectedIds, durum: newDurum });
      toast.success('Seçili kayıtlar güncellendi');
      load();
    } catch { toast.error('Toplu güncelleme başarısız'); }
  };

  const handleTahsilat = async (form) => {
    try {
      await axios.post('/muhasebe/tahsilat', form);
      toast.success('Tahsilat kaydedildi!');
      setTahsilatTaksit(null);
      if (secili) handleDetay(secili);
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'Hata'); }
  };

  const handleWhatsAppReminder = async (taksit) => {
    setWhatsAppSendingId(taksit.id);
    try {
      const { data } = await axios.post(`/muhasebe/taksitler/${taksit.id}/whatsapp`);
      if (!data?.success) {
        toast.error(data?.message || 'WhatsApp ödeme hatırlatması gönderilemedi.');
        return;
      }
      toast.success(data.message || 'WhatsApp ödeme hatırlatması gönderildi.');
    } catch (error) {
      const message = error.response?.data?.message || 'WhatsApp ödeme hatırlatması gönderilemedi.';
      toast.error(/şablon|sablon|template/i.test(message)
        ? `${message} Meta tarafında ödeme hatırlatma şablonunun tanımlı ve aktif olduğunu kontrol edin.`
        : message);
    } finally {
      setWhatsAppSendingId(null);
    }
  };

  const DURUM_RENK = { aktif:'#10B981', iptal:'#EF4444', tamamlandi:'#3B82F6', donduruldu:'#F59E0B' };
  const DURUM_ETIKET = { aktif:'Aktif', iptal:'İptal', tamamlandi:'Tamamlandı', donduruldu:'Donduruldu' };
  const TAKSIT_RENK = { odendi:'#10B981', bekliyor:'#3B82F6', gecikti:'#EF4444', iptal:'#94A3B8' };
  const detayFormBilgileri = detay?.sozlesme_form_bilgileri || {};
  const detayOgrenciAdi = getStudentName(detayFormBilgileri) !== '-'
    ? getStudentName(detayFormBilgileri)
    : `${detay?.ad || ''} ${detay?.soyad || ''}`.trim();

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{ fontFamily:'var(--font-ui)', fontWeight:900 }}>📋 Sözleşmeler</h2>
          <div className="section-subtitle">{total} toplam sözleşme</div>
        </div>
        
        <div className="muh-filter-row">
          {selectedIds.length > 0 && (
            <div className="bulk-actions-bar animate-fadeIn" style={{ display:'flex', gap:8, alignItems:'center', background:'var(--blue-dim)', padding:'4px 12px', borderRadius:12 }}>
              <span style={{ fontWeight:700, fontSize:'0.85rem', color:'var(--blue)' }}>{selectedIds.length} Seçili</span>
              <button className="btn btn-sm btn-outline" onClick={() => handleBulkStatus('aktif')}>Aktif</button>
              <button className="btn btn-sm btn-outline" onClick={() => handleBulkStatus('donduruldu')}>Dondur</button>
              <button className="btn btn-sm btn-outline" style={{ color:'#EF4444' }} onClick={handleBulkDelete}>Sil</button>
            </div>
          )}
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Yeni Sözleşme</button>
        </div>
      </div>

      <div className="card" style={{ padding:'12px 16px' }}>
        <div style={{ display:'flex', gap:8, overflowX:'auto', flexWrap:'nowrap', paddingBottom:2 }}>
          {['','aktif','tamamlandi','iptal','donduruldu'].map(d => (
            <button key={d} className={`chip ${filtre.durum===d?'active':''}`}
              style={{ flex:'0 0 auto' }}
              onClick={() => setFiltre(f => ({...f, durum:d, sayfa:1}))}>
              {d ? (DURUM_ETIKET[d] || d) : 'Tümü'}
            </button>
          ))}
        </div>
      </div>

      <div className={secili ? 'muh-two-col' : ''} style={{ display:'grid', gridTemplateColumns: secili ? '1.2fr 1fr' : '1fr', gap:16 }}>
        <div className="card animate-fadeInUp" style={{ padding:0 }}>
          {loading ? (
            <div className="page-loader" style={{ minHeight:200 }}><div className="spinner" /></div>
          ) : isMobile ? (
            <div style={{ padding: 12, display:'flex', flexDirection:'column', gap:10 }}>
              {sozlesmeler.length === 0 ? (
                <div className="empty-state" style={{ padding: 36 }}>
                  <h3>Kayıt bulunamadı</h3>
                </div>
              ) : sozlesmeler.map(s => (
                <div
                  key={s.id}
                  className="card"
                  onClick={() => handleDetay(s.id)}
                  style={{
                    cursor:'pointer',
                    padding: 12,
                    borderLeft: `4px solid ${DURUM_RENK[s.durum] || '#94A3B8'}`,
                    background: secili===s.id ? 'var(--blue-dim)' : 'var(--bg-card)',
                  }}
                >
                  <div style={{ display:'flex', justifyContent:'space-between', gap:10, alignItems:'flex-start' }}>
                    <label onClick={(e) => e.stopPropagation()} style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
                      <input type="checkbox" checked={selectedIds.includes(s.id)} onChange={() => toggleSelect(s.id)} />
                    </label>
                    <span className="badge" style={{ background:(DURUM_RENK[s.durum]||'#94A3B8')+'22', color:DURUM_RENK[s.durum]||'#94A3B8' }}>
                      {DURUM_ETIKET[s.durum] || s.durum}
                    </span>
                  </div>
                  <div style={{ fontWeight:800, marginTop: 6 }}>{s.ad} {s.soyad}</div>
                  <div style={{ fontSize:'0.78rem', color:'var(--text-muted)', marginTop:2 }}>{s.sinif_adi} · {s.egitim_yili}</div>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginTop:10 }}>
                    <div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>Net</div>
                    <div style={{ fontWeight:800, color:'var(--blue)', textAlign:'right' }}>{TL(s.net_ucret)}</div>
                    <div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>Ödenen</div>
                    <div style={{ fontWeight:700, color:'#10B981', textAlign:'right' }}>{TL(s.odenen_tutar)}</div>
                    <div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>Kalan</div>
                    <div style={{ fontWeight:700, color:s.kalan_tutar > 0 ? '#EF4444' : '#10B981', textAlign:'right' }}>{TL(s.kalan_tutar)}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="table-container">
              <table className="table">
                <thead>
                  <tr>
                    <th style={{ width: 40 }}><input type="checkbox" checked={selectedIds.length === sozlesmeler.length && sozlesmeler.length > 0} onChange={toggleSelectAll} /></th>
                    <th>Öğrenci</th><th>Paket</th><th>İndirim</th><th>Net Ücret</th><th>Ödenen</th><th>Kalan</th><th>Durum</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  {sozlesmeler.map(s => (
                    <tr key={s.id} style={{ cursor:'pointer', background: secili===s.id ? 'var(--blue-dim)' : '' }}
                      onClick={() => handleDetay(s.id)}>
                      <td onClick={e => e.stopPropagation()}>
                        <input type="checkbox" checked={selectedIds.includes(s.id)} onChange={() => toggleSelect(s.id)} />
                      </td>
                      <td>
                        <div style={{ fontWeight:700 }}>{s.ad} {s.soyad}</div>
                        <div style={{ fontSize:'0.72rem', color:'var(--text-muted)' }}>{s.sinif_adi} · {s.egitim_yili}</div>
                      </td>
                      <td style={{ fontSize:'0.82rem' }}>{s.paket}</td>
                      <td>
                        <span style={{ fontSize:'0.78rem', color:'#10B981', fontWeight:700 }}>
                          {parseFloat(s.indirim_tutar) > 0 ? `-${TL(s.indirim_tutar)}` : '—'}
                        </span>
                      </td>
                      <td style={{ fontFamily:'var(--font-ui)', fontWeight:800, color:'var(--blue)' }}>{TL(s.net_ucret)}</td>
                      <td style={{ color:'#10B981', fontWeight:700 }}>{TL(s.odenen_tutar)}</td>
                      <td style={{ color: s.kalan_tutar > 0 ? '#EF4444' : '#10B981', fontWeight:700 }}>{TL(s.kalan_tutar)}</td>
                      <td>
                        <span className="badge" style={{ background:(DURUM_RENK[s.durum]||'#94A3B8')+'22', color:DURUM_RENK[s.durum]||'#94A3B8' }}>
                          {DURUM_ETIKET[s.durum] || s.durum}
                        </span>
                      </td>
                      <td><button className="btn btn-outline btn-sm">Detay</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {secili && detay && (
          <div className="card animate-fadeInUp" style={{ padding:0 }}>
            <div style={{ padding:'14px 16px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
              <div>
                <div style={{ fontFamily:'var(--font-ui)', fontWeight:800 }}>{detayOgrenciAdi}</div>
                <div style={{ fontSize:'0.78rem', color:'var(--text-muted)' }}>
                  {detay.paket} · {detay.egitim_yili} · {detayFormBilgileri.sinif_adi || detay.sinif_adi || '-'}
                </div>
                
                <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
                   <select 
                    className="form-input" 
                    style={{ height: 28, fontSize: '0.75rem', width: 'auto', padding: '0 8px' }}
                    value={detay.durum}
                    onChange={(e) => handleStatusUpdate(detay.id, e.target.value)}
                   >
                     <option value="aktif">Aktif Yap</option>
                     <option value="donduruldu">Dondur</option>
                     <option value="iptal">İptal Et</option>
                     <option value="tamamlandi">Tamamlandı</option>
                   </select>
                   <button
                    className="btn btn-sm"
                    style={{ background: '#3B82F6', color: 'white', border: 'none', height: 28 }}
                    onClick={() => printCourseContract({
                      form: {
                        ...detay,
                        taksit_modu: 'manuel',
                        taksitler: detay.taksitler || [],
                        sozlesme_form_bilgileri: detayFormBilgileri,
                      },
                      student: detayFormBilgileri,
                      representativeName: [user?.ad, user?.soyad].filter(Boolean).join(' ')
                    })}
                   >
                     Yazdır
                   </button>
                   <button 
                    className="btn btn-sm" 
                    style={{ background: '#EF4444', color: 'white', border: 'none', height: 28 }}
                    onClick={() => handleDelete(detay.id)}
                   >
                     Sil
                   </button>
                </div>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={() => setSecili(null)}>✕</button>
            </div>

            <div className="muh-grid-4" style={{ padding:'12px 16px', gap:8, borderBottom:'1px solid var(--border)' }}>
              {[
                { l:'Brüt', v:TL(detay.brut_ucret), c:'var(--text-secondary)' },
                { l:'İndirim', v:TL(detay.indirim_tutar), c:'#10B981' },
                { l:'Net', v:TL(detay.net_ucret), c:'var(--blue)' },
                { l:'Kalan', v:TL(detay.taksitler?.filter(t=>t.durum!=='odendi'&&t.durum!=='iptal').reduce((s,t)=>s+parseFloat(t.tutar),0)), c:'#EF4444' },
              ].map((i,k) => (
                <div key={k} style={{ textAlign:'center', padding:'10px', background:'var(--bg-elevated)', borderRadius:10 }}>
                  <div style={{ fontFamily:'var(--font-ui)', fontWeight:900, fontSize: '0.85rem', color:i.c }}>{i.v}</div>
                  <div style={{ fontSize:'0.70rem', color:'var(--text-muted)' }}>{i.l}</div>
                </div>
              ))}
            </div>

            <div style={{ padding:'10px 16px', fontWeight:700, fontSize:'0.85rem', borderBottom:'1px solid var(--border)' }}>
              Taksit Planı
            </div>
            <div style={{ maxHeight:360, overflowY:'auto' }}>
              {(detay.taksitler || []).map((t, i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 16px', borderBottom:'1px solid var(--border)' }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:'0.875rem' }}>#{t.taksit_no} — {TL(t.tutar)}</div>
                    <div style={{ fontSize:'0.72rem', color:'var(--text-muted)' }}>
                      {new Date(t.vade_tarihi).toLocaleDateString('tr-TR')}
                      {(t.gercek_odeme || t.odeme_tarihi) && ` · Ödendi: ${new Date(t.gercek_odeme || t.odeme_tarihi).toLocaleDateString('tr-TR')}`}
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                    <span className="badge" style={{ background:(TAKSIT_RENK[t.durum]||'#94A3B8')+'22', color:TAKSIT_RENK[t.durum]||'#94A3B8' }}>
                      {t.durum}
                    </span>
                    {(t.durum==='bekliyor'||t.durum==='gecikti') && (
                      <button className="btn btn-sm" style={{ background:'#10B981', color:'white', border:'none' }}
                        onClick={() => setTahsilatTaksit({...t, ad:detayFormBilgileri.ad || detay.ad, soyad:detayFormBilgileri.soyad || detay.soyad})}>
                        💳 Al
                      </button>
                    )}
                    {canSendWhatsAppReminder && (t.durum==='bekliyor'||t.durum==='gecikti') && (
                      <button className="btn btn-sm" style={{ background:'#15803D', color:'white', border:'none' }}
                        disabled={whatsAppSendingId === t.id}
                        onClick={() => handleWhatsAppReminder(t)}>
                        {whatsAppSendingId === t.id ? 'Gönderiliyor…' : 'WhatsApp ile ödeme hatırlatması gönder'}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {showModal && <SozlesmeModal sablonlar={sablonlar} onSave={handleSave} onClose={() => setShowModal(false)} />}
      {tahsilatTaksit && <TahsilatModal taksit={tahsilatTaksit} onSave={handleTahsilat} onClose={() => setTahsilatTaksit(null)} />}
    </div>
  );
}
